import ScopeModal from './ScopeModal.component';

export default ScopeModal;
